import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import * as Icons from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
// import { useGetTickets } from 'pages/support/service/react-query/useGetTickets/useGetTickets'
import colors from 'styles/colors'

// import { TicketStatusZendesk } from '../Tickets/types/enums/TicketStatus'

declare global {
    interface Window {
        zE?: (...args: any[]) => void
    }
}

const useZendeskKeyboardViewport = () => {
    useEffect(() => {
        if (window.innerWidth > 768) return

        const visualViewport = window.visualViewport
        if (!visualViewport) return

        const viewportMeta = document.querySelector<HTMLMetaElement>(
            'meta[name="viewport"]'
        )

        const previousViewportContent =
            viewportMeta?.getAttribute('content') ?? ''

        viewportMeta?.setAttribute(
            'content',
            'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, interactive-widget=resizes-content'
        )

        const originalStyles = new Map<
            HTMLIFrameElement,
            {
                height: string
                top: string
                bottom: string
                maxHeight: string
            }
        >()

        const updateViewport = () => {
            const frame = document.querySelector<HTMLIFrameElement>(
                'iframe[title="Messaging window"]'
            )

            if (!frame) return

            if (!originalStyles.has(frame)) {
                originalStyles.set(frame, {
                    height: frame.style.height,
                    top: frame.style.top,
                    bottom: frame.style.bottom,
                    maxHeight: frame.style.maxHeight
                })
            }

            const height = Math.round(visualViewport.height)
            const top = Math.round(visualViewport.offsetTop)

            frame.style.setProperty(
                'height',
                `${height}px`,
                'important'
            )

            frame.style.setProperty(
                'max-height',
                `${height}px`,
                'important'
            )

            frame.style.setProperty(
                'top',
                `${top}px`,
                'important'
            )

            frame.style.setProperty(
                'bottom',
                'auto',
                'important'
            )
        }

        const observer = new MutationObserver(updateViewport)

        observer.observe(document.body, {
            childList: true,
            subtree: true
        })

        visualViewport.addEventListener('resize', updateViewport)
        visualViewport.addEventListener('scroll', updateViewport)

        updateViewport()

        return () => {
            observer.disconnect()

            visualViewport.removeEventListener(
                'resize',
                updateViewport
            )

            visualViewport.removeEventListener(
                'scroll',
                updateViewport
            )

            originalStyles.forEach((styles, frame) => {
                frame.style.height = styles.height
                frame.style.top = styles.top
                frame.style.bottom = styles.bottom
                frame.style.maxHeight = styles.maxHeight
            })

            if (viewportMeta) {
                viewportMeta.setAttribute(
                    'content',
                    previousViewportContent
                )
            }
        }
    }, [])
}

export const Home = () => {
    const { t } = useTranslation()

    /*
    const { data: tickets } = useGetTickets({ enabled: true })

    const pendingTickets = tickets?.message?.tickets?.filter(
        (ticket: { status: string }) =>
            ticket.status === TicketStatusZendesk.PENDING
    )

    const pendingTicketsNumber = pendingTickets?.length
    */
    useZendeskKeyboardViewport()
    const openLiveChat = () => {
        if (!window.zE) return

        window.zE('messenger', 'show')
        window.zE('messenger', 'open')
    }

/*     useEffect(() => {
        const existingScript = document.getElementById(
            'ze-snippet'
        ) as HTMLScriptElement | null

        if (!existingScript) {
            const script = document.createElement('script')

            script.id = 'ze-snippet'
            script.src =
                'https://static.zdassets.com/ekr/snippet.js?key=d1047c95-3de7-46cb-a73d-cf1378e2a188'
            script.async = true

            document.body.appendChild(script)
        }

        const interval = setInterval(() => {
            if (!window.zE) return

            clearInterval(interval)

            window.zE('messenger', 'show')
        }, 300)

        return () => {
            clearInterval(interval)

            if (window.zE) {
                window.zE('messenger', 'hide')
            }
        }
    }, []) */
useEffect(() => {
    const existingScript = document.getElementById(
        'ze-snippet'
    ) as HTMLScriptElement | null

    if (!existingScript) {
        const script = document.createElement('script')

        script.id = 'ze-snippet'
        script.src =
            'https://static.zdassets.com/ekr/snippet.js?key=d1047c95-3de7-46cb-a73d-cf1378e2a188'
        script.async = true

        document.body.appendChild(script)
    }

    const interval = setInterval(() => {
        if (!window.zE) return

        clearInterval(interval)

        window.zE('messenger', 'hide')
    }, 300)

    return () => {
        clearInterval(interval)
        window.zE?.('messenger', 'hide')
    }
}, [])
    return (
        <WithHeaderSection
            customClass='support-home'
            withoutBorder={true}
            headerSection={
                <StyledHeaderSection>
                    <Icons.supportIcon />

                    <StyledHeaderTitle>
                        {t('howCanWeHelpYou')}?
                    </StyledHeaderTitle>
                </StyledHeaderSection>
            }
        >
            <ActionCard
                text={t('howToFaq')}
                link='/how-to/faq'
                icon={<Icons.IconHowToBook />}
                absFix
                hasArrow
            />

            <ActionCard
                text={t('submitATicket')}
                link='/support/submit-ticket'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
                // pendingNumber={pendingTicketsNumber}
            />

            <ActionCard
                text={t('contactLiveChat')}
                icon={<Icons.chatBubbles />}
                clickFn={openLiveChat}
                absFix
                hasArrow
            />

            <StyledBorderLine />

            <ActionCard
                icon={<Icons.IconLightMessage />}
                text='support@allfans.com'
                suptext={t('sendUsAnEmail')}
            />
        </WithHeaderSection>
    )
}

const StyledBorderLine = styled.div`
    background-color: ${colors.platinumGray};
    height: 0.1rem;
    margin: 3rem 0;
`

const StyledHeaderSection = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
`

const StyledHeaderTitle = styled.h2`
    font-size: 2.4rem;
    font-weight: 600;
    line-height: 2.9rem;
    letter-spacing: 0.02em;
    margin-bottom: 2.4rem;
    margin-top: 3.6rem;
`